import React, { useState } from "react"
import userAvatarDefault from "../../../assets/img/user_avatar.svg"
import { generatePath, Link } from "react-router-dom"
import * as routes from "../../../library/constants/routes"
import DropdownControl from "../../ui/dropdowns/dropdownControl"
import MenuList from "@material-ui/core/MenuList/MenuList"
import Button from "@material-ui/core/Button/Button"
import {
  composeUserHighlightedEducation,
  composeUserHighlightedWork,
} from "../../../library/utils/getUserHighlightedInfo"
import { withStyles } from "@material-ui/core"
import { colors } from "../../../library/constants/styles/colors"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"

const CustomMenuItem = withStyles({
  root: {
    color: colors.primary,
  },
})(MenuItem)

const UsersPickerListItem = ({user, addUser, deleteUser, chosenUsers, canAdd}) => {
    const [isAdded, setIsAdded] = useState(!!chosenUsers.find(id => user.id === id));

    const onAddUser = async () => {
        addUser(user);
        setIsAdded(true);
    };

    const onDeleteUser = async () => {
        deleteUser(user.id);
        setIsAdded(false);
    };

    const photoUrl = user.photo !== "" ? user.photo : userAvatarDefault;
    const fullName = `${user.first_name} ${user.last_name}`;
    const profileUrl = generatePath(routes.USER, {userId: user.id});
    const addressInfoBlock = (user.city ? user.city : "") + (user.country ? `, ${user.country}` : "");

    return (
        <div className="box list-item">
            <div className="f aic full-width">
                <Link to={profileUrl} className="list-item__img">
                    <img src={photoUrl} alt={fullName}/>
                </Link>
                <div className="list-item__info">
                    <Link to={profileUrl} className="link list-item__name">{fullName}</Link>

                    {!!user.education && composeUserHighlightedEducation(user.education)}

                    {!!user.work && composeUserHighlightedWork(user.work)}

                    <span className="list-item__info-block">{!!addressInfoBlock && addressInfoBlock}</span>
                </div>
            </div>
            <div className="list-item__control-panel jcc">
                {isAdded ? (
                    <div className="f jcc">
                        <DropdownControl buttonLabel="Added to guests">
                            <MenuList>
                                <CustomMenuItem onClick={onDeleteUser}>
                                    Remove
                                </CustomMenuItem>
                            </MenuList>
                        </DropdownControl>
                    </div>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={onAddUser}
                        disabled={!canAdd}
                    >
                        Add to guests
                    </Button>
                )}
            </div>
        </div>
    );
};

export default UsersPickerListItem;
